import type { PlainAuthenticationMethodPersonalAccessToken, PlainRunner } from "@/queries/runner-queries";
import { Code, ConnectError } from "@connectrpc/connect";
import { atom } from "jotai";

export const activeTabAtom = atom<TabValue | undefined>(undefined);
export const escapePressCallbackAtom = atom<null | { fn: () => void }>(null);

export type CreateEnvironmentStage =
    | { type: "input" }
    | {
          type: "scm-authentication";
          authenticationUrl: string;
          patAuth?: PlainAuthenticationMethodPersonalAccessToken;
          scmId: string;
          scmName: string;
          runner: PlainRunner;
          contextUrl: string;
          onClickContinue?: () => void;
      };

export const TabsValues = {
    project: "project",
    url: "url",
    scratch: "scratch",
    home: "home", // home is only supported in the v2 of CreateEnvironmentDetailsLayout
} as const;
export type TabValue = (typeof TabsValues)[keyof typeof TabsValues];

export const isNoSuitableRunnerFoundError = (error: unknown) => {
    return (
        error instanceof ConnectError &&
        error.code === Code.NotFound &&
        error.message.includes("no suitable runner found")
    );
};
